import { useState } from "react";
import { useParams } from "react-router";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useDynamicPortfolios } from "@/lib/hooks/use-portfolio-collections";
import { useT } from "@/lib/i18n/use-t";

import { type PortfolioView, PortfolioViewToggle } from "../portfolio-weights";
import { TableCardSkeleton } from "../skeleton-loaders";
import { DynamicPortfoliosGrid } from "./dynamic-portfolios-grid";
import { DynamicPortfoliosTable } from "./dynamic-portfolios-table";
import { T } from "./page.i18n";

export default function DynamicPortfoliosPage() {
  const { id } = useParams<{ id: string }>();
  const { dynamicPortfolios, error, isLoading } = useDynamicPortfolios(id!);
  const t = useT(T);
  const [view, setView] = useState<PortfolioView>("list");

  if (isLoading) {
    return <TableCardSkeleton columns={4} />;
  }

  if (error) {
    return (
      <Alert variant="destructive">
        <AlertDescription>{t.failedToLoad}</AlertDescription>
      </Alert>
    );
  }

  return (
    <div>
      <PortfolioViewToggle view={view} onChange={setView} />
      {view === "list" ? (
        <DynamicPortfoliosTable portfolioCollectionId={id!} dynamicPortfolios={dynamicPortfolios} />
      ) : (
        <DynamicPortfoliosGrid portfolioCollectionId={id!} dynamicPortfolios={dynamicPortfolios} />
      )}
    </div>
  );
}
